export default function ResourceService($http, API_SERVER, Log, DummyApi, $q) {
    var fn = this;

    /**
     * API V3
     */

    fn.get = (id) => {
        // Endpoint:
        const endpoint = `/resources/${id}/`;

        const params = `&expand=parent`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.get(url).then((res) => {
            return res.data;
        });
    };

    fn.getAll = () => {
        // Endpoint:
        const endpoint = `/resources/`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        const headers = {
            endpointType: "noTokenRequired", // used by interceptor to skip access token
        };

        return $http.get(url, { cache: true, headers: headers }).then((res) => {
            return res.data;
        });
    };

    fn.getEntries = (id, start, end) => {
        let endpoint = `/resources/${id}/entries`;

        if (start && end) {
            endpoint += `?start=${start}&end=${end}`;
        }

        const url = API_SERVER + endpoint;
        Log.endpoint(endpoint, url);
        return $http.get(url, { cache: true }).then((res) => {
            return res.data;
        });
    };

    fn.getDependencies = (id) => {
        // if (DummyApi.isEnabled()) {
        //     return $q.resolve(DummyApi.???????(id));
        // }

        // Endpoint:
        const endpoint = `/resources/dependencies`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        const headers = {
            endpointType: "noTokenRequired", // used by interceptor to skip access token
        };

        return $http.get(url, { cache: true, headers: headers }).then((res) => {
            return res.data;
        });
    };

    return fn;
}
